import React, { Component } from 'react';
import {ErrorMessage, Field, Form, Formik} from "formik";
import {Redirect} from "react-router";
import { withTranslation } from 'react-i18next';
import SecondHeader from "./Parts/SecondHeader";
import Header from "./Parts/Header";
import SubHeader from "./Parts/SubHeader";
import Loading from "./Parts/Loading";
import { Checkbox, TextField } from "../Fields";
import AppContext from "../../contexts/AppContext";

class Incomes extends Component {

    static contextType = AppContext;

    constructor(props) {
        super(props);

        this.state = {
            data: {
                personal_code: '',
                incomes: '',

                amount_cl: '',
                amount_mortgage: '',
                amount_other: '',

                knows_bonus_code: false,
                bonus_code: '',
            },
            has_liabilities: false,
            knows_about_future_financial_changes: false,
            step_count: 3,
            current_step: 2,

            redirectToNextStep: false,
            // redirecting with component is mentioned as best practice (in opposite to doing it programmatically)
            // https://tylermcginnis.com/react-router-programmatically-navigate/
            backToFirstStep: false,

            gtmEventSent: false,
        };

        this.formSubmit = this.formSubmit.bind(this);
        this.renderForm = this.renderForm.bind(this);
        this.handleOptionChange = this.handleOptionChange.bind(this);
        this.handleLiabilityChange = this.handleLiabilityChange.bind(this);
        this.returnToContacts = this.returnToContacts.bind(this);
    }

    componentDidUpdate(prevProps, prevState) {
        if (
            this.props.suggestion.application.id !== undefined
            && this.props.suggestion.application.id !== null
            && !this.state.gtmEventSent
            && !this.state.backToFirstStep
        ) {
            gtm.sendEvent('base', {
                orderID: this.props.suggestion.application.id,
                event: 'checkoutunregistered2',
                products: {
                    price: this.props.suggestion.amount,
                    variant: this.props.suggestion.term,
                    product_code: this.props.suggestion.product,
                    product_type: this.props.suggestion.type
                },
                actionField: { step: 2, action: 'personalDetails' },
                pageTitle: 'Registration 2/4, personal details',
                eventId: 3208
            });
            this.setState({ gtmEventSent: true });
        }
    }

    returnToContacts() {
        this.setState({ backToFirstStep: true });
    }

    handleOptionChange(changeEvent) {
        this.setState({
            knows_about_future_financial_changes: changeEvent.target.value === 'yes'
        });
        if (changeEvent.target.value === 'yes') {
            document.querySelector(`#incomes`)?.focus();
        }
    }

    handleLiabilityChange(changeEvent) {
        this.setState({ has_liabilities: changeEvent.target.checked })
    }

    renderForm(props) {

        const { t, suggestion } = this.props;
        const { knows_about_future_financial_changes, has_liabilities } = this.state;

        return (
            <Form className="form form-layout mt-5">
                <div className="container form-layout__2-col">
                    <div className="form-group  col-md-6 col-lg-6">
                        <label className="form-label"
                               htmlFor="personal_code">{t('forms.personal_code')}</label>
                        <Field
                            autoFocus={true}
                            type="text"
                            name="personal_code"
                            id="personal_code"
                            disabled={props.isSubmitting}
                            className={'form-control' + (props.errors.personal_code && props.touched.personal_code ? ' is-invalid' : '')}
                        />
                        <ErrorMessage name="personal_code" component="div" className="invalid-feedback"/>
                    </div>

                    <div className="form-group  col-md-6 col-lg-6">
                        <label className="form-label" htmlFor="incomes">{t('forms.monthly_income')}</label>
                        <Field type="number" name="incomes" id="incomes" disabled={props.isSubmitting}
                               className={'form-control' + (props.errors.incomes && props.touched.incomes ? ' is-invalid' : '')}
                        />
                        <ErrorMessage name="incomes" component="div" className="invalid-feedback"/>
                    </div>

                    <div className="col-12 mt-3">
                        <div className="mb-2">{t('forms.do_you_know')}</div>
                        <div className="d-flex">
                            <div className="form-group mr-4">
                                <div className="custom-control custom-radio">
                                    <input type="radio"
                                           id="radiobuttonExample1"
                                           className="custom-control-input"
                                           value="yes"
                                           checked={knows_about_future_financial_changes}
                                           disabled={props.isSubmitting}
                                           onChange={this.handleOptionChange}
                                    />
                                    <label className="custom-control-label"
                                           htmlFor="radiobuttonExample1">{t('forms.yes')}</label>
                                </div>
                            </div>
                            <div className="form-group">
                                <div className="custom-control custom-radio">
                                    <input type="radio" id="radiobuttonExample2"
                                           className="custom-control-input"
                                           value="no"
                                           checked={!knows_about_future_financial_changes}
                                           disabled={props.isSubmitting}
                                           onChange={this.handleOptionChange}
                                    />
                                    <label className="custom-control-label"
                                           htmlFor="radiobuttonExample2">{t('forms.no')}</label>
                                </div>
                            </div>
                        </div>
                    </div>
                    {knows_about_future_financial_changes &&
                    <div className="col-12  mb-4" style={{color: "#470A68"}}>
                        {t('forms.enter_expected_income')}
                    </div>
                    }

                    <div className="form-group col-12  mb-4">
                        <div className="custom-control custom-checkbox mt-3">
                            <input type="checkbox" className="custom-control-input" id="customCheck2"
                                   name="customCheck" checked={has_liabilities}
                                   disabled={props.isSubmitting}
                                   onChange={this.handleLiabilityChange}/>
                            <label className="custom-control-label" htmlFor="customCheck2">
                                {t('forms.has_liabilities')}
                                <i className="icons icon-question-circle" data-toggle="tooltip"
                                   data-placement="top" title={t('forms.liabilities_tooltip')}></i>
                            </label>
                        </div>
                    </div>

                    {has_liabilities &&
                    <div className="col-12 col-lg-4 col-md-6 liabilities-input">
                        <div className="form-group">
                            <label htmlFor="amount_cl">{t('forms.your_credit_liabilities')}</label>
                            <div className="input-group">
                                <Field type="number" name="amount_cl" id="amount_cl" disabled={props.isSubmitting}
                                       className={'form-control' + (props.errors.amount_cl && props.touched.amount_cl ? ' is-invalid' : '')}/>
                                <div className="input-group-append ">
                                    <div className="input-group-text bg-white border-left-0">
                                        {t('forms.eur_per_month')}
                                    </div>
                                </div>
                            </div>
                            <ErrorMessage name="amount_cl" component="div"
                                          className="invalid-feedback definitely-show"/>
                        </div>
                    </div>
                    }

                    {has_liabilities &&
                    <div className="col-12 col-lg-4 col-md-6 liabilities-input">
                        <div className="form-group">
                            <label htmlFor="amount_mortgage">{t('forms.your_mortgage_liabilities')}</label>
                            <div className="input-group">
                                <Field type="number" name="amount_mortgage" id="amount_mortgage"
                                       disabled={props.isSubmitting}
                                       className={'form-control' + (props.errors.amount_mortgage && props.touched.amount_mortgage ? ' is-invalid' : '')}/>
                                <div className="input-group-append ">
                                    <div className="input-group-text bg-white border-left-0">
                                        {t('forms.eur_per_month')}
                                    </div>
                                </div>
                            </div>
                            <ErrorMessage name="amount_mortgage" component="div"
                                          className="invalid-feedback  definitely-show"/>
                        </div>
                    </div>
                    }

                    {has_liabilities ? (
                            <div className="col-12 col-lg-4 col-md-6 liabilities-input">
                                <div className="form-group">
                                    <label htmlFor="amount_other">{t('forms.your_other_liabilities')}</label>
                                    <div className="input-group">
                                        <Field type="number" name="amount_other" id="amount_other"
                                               disabled={props.isSubmitting}
                                               className={'form-control' + (props.errors.amount_other && props.touched.amount_other ? ' is-invalid' : '')}/>
                                        <div className="input-group-append ">
                                            <div className="input-group-text bg-white border-left-0">
                                                {t('forms.eur_per_month')}
                                            </div>
                                        </div>
                                    </div>
                                    <ErrorMessage name="amount_other" component="div"
                                                  className="invalid-feedback  definitely-show"/>
                                </div>
                            </div>)
                        : ''}


                    {has_liabilities &&
                    <p className="col-12 text-muted">{t('forms.liabilities_explanation')}</p>
                    }

                    {!suggestion.is_eshop &&
                    <div className="form-group col-12  mb-4">
                        <Checkbox name='knows_bonus_code'
                                  disabled={props.isSubmitting}
                                  label={t('forms.know_bonus_code')}
                                  {...props}
                        />
                    </div>
                    }

                    {props.values.knows_bonus_code &&
                    <div className="form-group col-12  mb-4">
                        <TextField name='bonus_code'
                                   disabled={props.isSubmitting}
                                   label={t('forms.bonus_code')}
                                   {...props}
                        />
                    </div>
                    }

                    <div className="form-group col-12 d-flex justify-content-center mt-3">
                        <button type="submit" className="btn btn-primary btn-lg"
                                disabled={props.isSubmitting}>
                            {t('forms.next')}
                        </button>
                    </div>
                    <div className="form-group col-12 d-flex justify-content-center mt-3"
                         onClick={this.returnToContacts}
                    >
                        <span className="fake-link">{t('change_contacts')}</span>
                    </div>
                </div>
            </Form>);
    }

    formSubmit(values, actions) {

        //new version
        gtm.sendEvent('base', {
            event: 'loan_application_form.continued',
            products: {
                loan_amount: this.props.suggestion.amount,
                loan_period: this.props.suggestion.term,
                product_code: this.props.suggestion.application?.appl_product,
            }
        }, 2);

        const { clearError } = this.context;
        clearError();

        values.knownIncomeChanges = this.state.knows_about_future_financial_changes;

        axios.post('/api/process/' + this.props.application_token + '/incomes', values)
            .then(
                data => {
                    actions.setSubmitting(false);
                    if (data.data.status === 'success') {
                        this.setState({ redirectToNextStep: true });
                    }
                },
                error => {
                    let response_data = error.response.data;
                    actions.setSubmitting(false);
                    actions.setErrors(response_data.errors);
                }
            );
    }

    render() {
        const { hasError } = this.context;
        const { application_token, suggestion, t} = this.props;
        const { redirectToNextStep, backToFirstStep, step_count, current_step, data } = this.state;

        if (redirectToNextStep) {
            return <Redirect push={true} to={'/' + application_token + '/process/consent'}/>
        }

        if (backToFirstStep) {
            if (!suggestion.is_eshop || suggestion.type === 'IP') {
                return <Redirect push={true} to={'/' + application_token + '/process/contacts'} />
            } else {
                return <Redirect push={true} to={'/eshop/' + application_token}/>
            }
        }

        let { eshop_data, type } = suggestion;

        if (eshop_data.client_pers_code && (type && type != 'IP')) {
            this.state.data.personal_code = eshop_data.client_pers_code;
        }

        return (
            <div>
                <Header title={t('step.registration')}/>

                <div className="section window-layout">
                    <div className="container frame">
                        <SubHeader title={t('substep.incomes')}
                                   step_count={step_count}
                                   current_step={current_step}/>

                        {suggestion.loading && !hasError &&
                            <div className="row">
                                <div className="form-layout mt-5">
                                    <Loading/>
                                </div>
                            </div>
                        }

                        {!suggestion.loading &&
                            <div className="row">
                                <SecondHeader suggestion={suggestion} />
                                <Formik
                                    initialValues={data}
                                    onSubmit={this.formSubmit}
                                    render={this.renderForm}
                                    enableReinitialize
                                />
                            </div>
                        }
                    </div>
                </div>
            </div>
        )
    }
}

export default withTranslation()(Incomes);
